import React, { useEffect, useState } from 'react';
interface CountdownTimerProps {
  minutes?: number;
}
export function CountdownTimer({
  minutes = 15
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState(minutes * 60);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timerId = setInterval(() => setTimeLeft(prev => prev - 1), 1000);
    return () => clearInterval(timerId);
  }, [timeLeft]);
  const h = Math.floor(timeLeft / 3600);
  const m = Math.floor(timeLeft % 3600 / 60);
  const s = timeLeft % 60;
  const format = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex items-center gap-2 md:gap-4 justify-center md:justify-start" data-id="element-21">
      <div className="flex flex-col items-center" data-id="element-22">
        <span className="text-gradient-gold text-2xl md:text-4xl font-display font-bold" data-id="element-23">
          {format(h)}
        </span>
        <span className="text-xs text-muted-foreground uppercase tracking-wider mt-1" data-id="element-24">
          Horas
        </span>
      </div>
      <span className="text-gradient-gold text-2xl md:text-4xl font-display font-bold pb-5" data-id="element-25">
        :
      </span>
      <div className="flex flex-col items-center" data-id="element-26">
        <span className="text-gradient-gold text-2xl md:text-4xl font-display font-bold" data-id="element-27">
          {format(m)}
        </span>
        <span className="text-xs text-muted-foreground uppercase tracking-wider mt-1" data-id="element-28">
          Min
        </span>
      </div>
      <span className="text-gradient-gold text-2xl md:text-4xl font-display font-bold pb-5" data-id="element-29">
        :
      </span>
      <div className="flex flex-col items-center" data-id="element-30">
        <span className="text-gradient-gold text-2xl md:text-4xl font-display font-bold" data-id="element-31">
          {format(s)}
        </span>
        <span className="text-xs text-muted-foreground uppercase tracking-wider mt-1" data-id="element-32">
          Seg
        </span>
      </div>
    </div>;
}